export default {"src":"/_next/static/media/shapes.8d9f012a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};